import { render, staticRenderFns } from "./SPIFProfileValuationMultiples.vue?vue&type=template&id=b78c5a16"
import script from "./SPIFProfileValuationMultiples.vue?vue&type=script&lang=js"
export * from "./SPIFProfileValuationMultiples.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileValuationMultiples.vue?vue&type=style&index=0&id=b78c5a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports